import React from 'react';
import { Modal } from 'react-bootstrap';

import FittingRecordListContainer from '../containers/FittingRecordListContainer.jsx';
import FittingRecordEditContainer from '../containers/FittingRecordEditContainer.jsx';

export default class FittingRecordsComponent extends React.Component {

  componentDidMount() {
  }

  render() {
    return (
      <div>
        <FittingRecordListContainer orderId={this.props.orderId} />
        <Modal bsSize="large" show={this.props.showFittingRecordModal} onHide={this.props.closeModal} backdrop="static">
          <Modal.Header closeButton />
          <Modal.Body>
            <FittingRecordEditContainer />
          </Modal.Body>
        </Modal>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/FittingRecordsComponent.jsx